import ApiService from '../common/api.service'

class CountriesService extends ApiService {
  getCountries () {
    return this.get('/countries', {}).then((res) => { return Promise.resolve(res.data) })
  }

}

export default CountriesService



// WEBPACK FOOTER //
// ./src/app/services/countries/countries.service.js